module.exports = __webpack_public_path__ + "static/media/cq_editor_testo_sinistra.38b7427f.svg";